<template>
    <div class="account-sidebar">
        <h2>{{ titleName }}</h2>
        <ul class="account-menu">
            <li
                v-for="item in menuList"
                :key="item.key"
                :class="{ active: currentActiveMenu === item.key }"
                @click="handleMenuClick(item)"
                style="cursor: pointer;"
            >
                <template v-if="item.href">
                    <router-link :to="item.href" class="txt">{{ t(item.label) }}</router-link>
                </template>
                <template v-else>
                    <span class="txt">{{ t(item.label) }}</span>
                </template>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'
import { ref, computed } from 'vue'

const { t } = useI18n()
const router = useRouter()
const route = useRoute()
defineProps<{ activeMenu?: string, titleName?: string }>()

// 计算当前活跃的菜单项
const currentActiveMenu = computed(() => {
  // 如果是招标/投标页面，根据路由参数判断
  if (route.name === 'PersonTenderList') {
    const type = route.params.type as string
    return type === '1' ? 'personTenderList1' : 'personTenderList2'
  }
  
  // 其他页面根据路由路径匹配
  const currentPath = route.path
  if (currentPath.includes('/orderPage')) return 'orderHistory'
  if (currentPath.includes('/waitPayOrder')) return 'waitPayOrder'
  if (currentPath.includes('/ReleaseTaskList')) return 'releaseHistory'
  if (currentPath.includes('/coupons')) return 'coupons'
  if (currentPath.includes('/favorite')) return 'favorite'
  if (currentPath.includes('/invitationCode')) return 'invitationCode'
  if (currentPath.includes('/profile-information')) return 'profileInformation'
  if (currentPath.includes('/profile-address')) return 'shippingAddresses'
  if (currentPath.includes('/messages')) return 'messages'
  if (currentPath.includes('/company-information')) {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    return userInfo.userType === '01' ? 'merchantInformation' : 'companyInformation'
  }
  
  return ''
})

const emit = defineEmits([ 'login-success'])

const userInfo = ref<{userType?: string}>({})
userInfo.value = JSON.parse(localStorage.getItem('userInfo') || '{}')
const userType = computed(() => userInfo.value.userType)
console.log('userType~~~~', userType.value);
const baseMenuList = [
    { key: 'orderHistory', label: 'profile.orderHistory', href: "/orderPage" },
    { key: 'waitPayOrder', label: 'profile.waitPayOrder', href: "/waitPayOrder" },
    { key: 'releaseHistory', label: 'profile.releaseHistory', href: "/ReleaseTaskList" },
    { key: 'coupons', label: 'profile.coupons', href: "/coupons" },
    { key: 'favorite', label: 'profile.favorite', href: "/favorite" },
    { key: 'invitationCode', label: 'profile.invitationCode', href: "/invitationCode" },
    // { key: 'buyAgain', label: 'profile.buyAgain', href: undefined },
    // { key: 'myList', label: 'profile.myList', href: "/orderPage/order-OrderList" },
    { key: 'profileInformation', label: 'profile.profileInformation', href: "/profile-information" },
    { key: 'shippingAddresses', label: 'profile.shippingAddresses', href: "/profile-address" },
    // { key: 'paymentMethods', label: 'profile.paymentMethods', href: "/paymentPage" },//支付方式
    // { key: 'buyNow', label: 'profile.buyNow', href: "/profile-buyNowSetting" },//立即购买
    // { key: 'myBookings', label: 'profile.myBookings', href: undefined },
    // { key: 'emailSubscriptions', label: 'profile.emailSubscriptions', href: undefined },
    { key: 'messages', label: 'profile.messages', href: "/messages" },
    { key: 'personTenderList2', label: 'tender.myTenders', href: "/personTender-list/2" },
    { key: 'personTenderList1', label: 'tender.myBids', href: "/personTender-list/1" }
]

// 根据 userType 动态添加公司或商家信息菜单
const menuList = computed(() => {
  const list = [...baseMenuList]
  // 插入到第六位（下标5）
  if (userType.value === '01') {
    list.splice(5, 0, {
      key: 'merchantInformation',
      label: 'profile.merchantSettings',
      href: '/company-information'
    })
  } else if (userType.value === '02') {
    list.splice(5, 0, {
      key: 'companyInformation',
      label: 'profile.companySettings',
      href: '/company-information'
    })
  }
  return list
})

// 菜单点击事件
async function handleMenuClick(item: any) {
  if (item.href) {
    router.push(item.href)
  }
}
</script>

<style scoped>
/* 可复制原有样式 */
.account-menu {
    list-style: none;
}

.account-menu li {
    margin-bottom: 12px;
}

.account-menu li a {
    color: #4a5568;
    text-decoration: none;
    font-size: 15px;
    transition: color 0.2s;
}

.account-menu li a:hover {
    color: #fb6e01;
}

.account-menu li.active a,
.account-menu li.active span {
    color: #fb6e01;
    font-weight: 600;
}

.account-menu li a,
.account-menu li span {
    font-size: 15px;
}


.account-sidebar {
    width: 250px;
    background-color: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    height: fit-content;
}

.account-sidebar h2 {
    font-size: 20px;
    color: #1a365d;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}
@media (max-width: 768px) {
    .account-sidebar {
        width: 100%;
    }
  
}
</style>